import consumer from "./consumer"

window.initiateCloneChannel = function(targetSurveyId, enqueueUrl, sourceSurveyId, completedAt, statuses, responseIds) {
  if (!targetSurveyId || !sourceSurveyId) return;

  const currentUser = window.dataLayer && window.dataLayer[0] ? window.dataLayer[0].userId : null;

  const subscription = consumer.subscriptions.create({
    channel: "SurveyResponseCloneChannel",
    survey_id: targetSurveyId,
    requester_id: currentUser
  }, {
    connected() {
      // Subscription confirmed — only now enqueue the job so its broadcast can't beat us to the stream.
      const token = document.querySelector("meta[name='csrf-token']")?.content;
      fetch(enqueueUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: { "X-CSRF-Token": token, "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ source_survey_id: sourceSurveyId, completed_at: completedAt, statuses: statuses, response_ids: responseIds })
      });
    },
    received(data) {
      const progressBar = document.getElementById("clone-progress");
      const progressText = document.getElementById("clone-progress-text");
      const progressStep = document.getElementById("clone-progress-step");
      const successContainer = document.getElementById("clone-success");
      const successCount = document.getElementById("clone-success-count");
      const errorContainer = document.getElementById("clone-error");
      const errorMessage = document.getElementById("clone-error-message");

      if (data.progress !== undefined) {
        progressBar.style.width = `${data.progress}%`;
        progressBar.setAttribute("aria-valuenow", data.progress);
        progressText.textContent = `${data.progress}%`;
      }

      if (data.done) {
        progressStep.classList.add("d-none");
        if (successCount) successCount.textContent = data.count;
        successContainer.classList.remove("d-none");
      }

      if (data.error) {
        progressStep.classList.add("d-none");
        errorMessage.textContent = data.error;
        errorContainer.classList.remove("d-none");
      }
    }
  });

  $("#clone-responses-modal").on("hidden.bs.modal", function() {
    subscription.unsubscribe();
  });

  return subscription;
};
